import yup, { string, mixed, object, boolean } from 'yup'
import { SchemaRules } from './schemaValidator'

const validationMessage = 'This field is required.'

export const createFacilityAddressSchema = {
  addressLine1: string().required(validationMessage),
  addressLine2: string().nullable(),
  locality: string().required(validationMessage),
  subdivisionCode: string().required(validationMessage),
  postalCode: string().nullable(),
  addressee: string().nullable(),
  id: mixed(),

  // Used strictly for controlling state in form
  isSavingFacility: boolean(),
}

const createFacilityAddressSchemaTypes = object(createFacilityAddressSchema)

export type CreateFacilityAddressSchema = Partial<
  yup.InferType<typeof createFacilityAddressSchemaTypes>
>

const createFacilityAddressValidator = new SchemaRules<CreateFacilityAddressSchema>(
  createFacilityAddressSchema
)
export default createFacilityAddressValidator
